import React, { useEffect, useRef } from 'react';
import { LabelPage } from 'src/pages/OfferPage/CableLabel/labelpage';
import { getFloorNameForRoom, getRoomById } from 'src/utils/projectTreeAdapterForOfferPage';
import { GetProjectTreeProjectChildNode } from 'src/model/api/get-project-tree-project-childnode.model';
import $ from "jquery";
import { GetRoutingLinesResponse } from 'src/model/api/get-routing-lines-response.model';
import { QuotePlaceholderBlurImg } from 'src/pages/OfferPage/pinouts/Pinout/QuotePlaceholderBlurImg';
import 'src/pages/OfferPage/CableLabel/CableLabel.css';
import { GetFloorRoomsDevice } from 'src/model/api/v2/data-contracts';
import { getFrontendURL } from 'src/utils/url';

export function CableLabel({enabled, devices, routingLines, projectTreeNodes}:
                           {
                             enabled: boolean,
                             devices: GetFloorRoomsDevice[],
                             routingLines: GetRoutingLinesResponse,
                             projectTreeNodes: GetProjectTreeProjectChildNode[]
                           }) {

  const labelRef = useRef<any>(null);

  let deviceSymbolIds = mapDeviceSymbols(devices, projectTreeNodes);
  appendWiringSymbols(deviceSymbolIds, routingLines);
  const gotLabels = Array.isArray(deviceSymbolIds) && deviceSymbolIds.length > 0;

  useEffect(() => {
    if (gotLabels) {
      let labelpage = new LabelPage(
          $(labelRef.current),
          deviceSymbolIds
      );
      labelpage.resultToContainer();
    }
  }, [devices, routingLines, projectTreeNodes]);

  return gotLabels ? (
      <>
        <div
            style={enabled ? {} : {display: 'none'}}
            className="cable-label-page row"
            ref={labelRef}
        ></div>
      </>
  ) : !gotLabels && enabled ? (
      <>
        <QuotePlaceholderBlurImg
          cls="pinout lightshadow"
          opacity={1}
          num={2}
          img={`${getFrontendURL()}/images/pinoutplaceholder.png`}
        />
      </>
  ) : null;
}

export function mapDeviceSymbols(devices: any[], projectTreeNodes: GetProjectTreeProjectChildNode[]): any[] {
  let deviceSymbolIds: any[] = [];
  let currentSymbolIdsObj: any = {};
  devices.filter(function (device) {
    return !!device.symbol_id;
  })
  .forEach(function (device) {
    const symid = device.symbol_id.split("_");
    const floorName = getFloorNameForRoom(device.roomId, projectTreeNodes)
    .substring(0, 2)
    .toUpperCase();
    const room = getRoomById(device.roomId, projectTreeNodes);
    const roomName = room
        ? room.text.substring(0, 2).toUpperCase()
        : "";

    const sym = `${symid[0]}_${floorName}_${roomName}_${symid[1]}`;
    currentSymbolIdsObj[sym] = true;
  });
  let currentSymbolIdsArr: any[] = [];

  for (let key in currentSymbolIdsObj) {
    currentSymbolIdsArr.push(key, key);
  }

  deviceSymbolIds = deviceSymbolIds.concat(currentSymbolIdsArr);
  return deviceSymbolIds
}

function appendWiringSymbols(deviceSymbolIds: any[], routingLines: GetRoutingLinesResponse) {
  for (let svg of routingLines.svgs) {
    const wiringLayersSVG = $(svg);
    const wiringLabels = wiringLayersSVG.find(".wire-label");

    const wiringLabelsObj: any = {};
    wiringLabels.each(function () {
      const text = $(this).text();
      wiringLabelsObj[text] = true;
    });
    for (let label in wiringLabelsObj) {
      deviceSymbolIds.push(label, label);
    }
  }

}

